import { useEffect, useState } from 'react';
import { faEllipsis } from '@fortawesome/pro-solid-svg-icons';
import { Menu } from '../view-models/library.viewMappers';
import { clsx } from 'clsx';
import { sprinkles } from '@design-system/sprinkles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@design-system/components/typography/typography';

export const GalleryItemMenu = ({ menu }: { menu: Menu }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const click = function () {
      setOpen(false);
    };
    document.addEventListener('click', click);

    return () => document.removeEventListener('click', click);
  }, []);

  return (
    <div className={'relative, max-w-fit flex flex-col justify-end'}>
      <div
        className={clsx(
          'self-end cursor-pointer flex items-center justify-center w-[20px] h-[20px] rounded-[4px]',
          sprinkles({ bg: 'W-100/15' }),
        )}
        onClick={(ev) => {
          ev.stopPropagation();
          setOpen((prev) => !prev);
        }}
      >
        <FontAwesomeIcon icon={faEllipsis} className="w-3 h-3" />
      </div>
      <div
        className={clsx(
          'flex flex-col justify-end rounded-[10px] absolute top-3 right-3',
          !open && 'hidden',
          open && 'flex',
        )}
        style={{ zIndex: 10 }}
      >
        {menu.map(({ text, onClick, className, to }) => (
          <div
            key={text}
            className={clsx(
              `bg-white hover:bg-[#EEE] w-full p-4 first:rounded-t-[10px] last:rounded-b-[10px] cursor-pointer`,
              className,
            )}
            onClick={(ev) => {
              ev.stopPropagation();
              onClick();
              setOpen(false);
            }}
          >
            {to ? (
              <a
                className="text-black"
                href={to}
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                <Typography variant="body" size="large" className={className}>
                  {text}
                </Typography>
              </a>
            ) : (
              <Typography
                variant="body"
                size="large"
                as="span"
                className={clsx(sprinkles({ width: '100%' }))}
              >
                {text}
              </Typography>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
